export enum StoryApiVersionType {
  Draft = 'draft',
  Published = 'published',
}

export enum StorySlug {
  Home = 'home',
  News = 'news',
  Work = 'work',
  Solutions = 'solutions',
  Services = 'services',
  Cases = 'cases',
  Location = 'location', // eg location/united-kingdom
  Locations = 'locations', // the /locations page with list of offices locations
  People = 'people',
}

export const globalSettingsSlug = 'global_settings';

export enum StoryCdnPath {
  Stories = 'cdn/stories',
  Tags = 'cdn/tags',
  Datasources = 'cdn/datasources',
  Links = 'cdn/links',
  Space = 'cdn/spaces/me',
}

export type StoryApiVersion =
  typeof StoryApiVersionType.Draft | typeof StoryApiVersionType.Published;

export type StaticPaths = Array<{
  params: { [key: string]: Array<string> | string | boolean };
  locale?: string;
}>;
